exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".p-mypage__heading[data-v-f560a4c4]{font-weight:700;font-size:14px;text-align:center}.p-mypage__heading>strong[data-v-f560a4c4]{color:#8cc63f;font-size:20px}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-f560a4c4","scoped":true,"sourceMap":false}!./node_modules/sass-loader/lib/loader.js!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/assets/js/utvStore/components/ProfileViewer.vue
// module id = Ls/m
// module chunks = 0